import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const verificationPerson = (idCard) => {
  const url = `${API_ROOT}/proposal/verification/person/${idCard}`
  return doGet(url)
}

export const verificationOrganization = (taxId) => {
  const url = `${API_ROOT}/proposal/verification/organization/${taxId}`
  return doGet(url)
}

export const verificationThaiDPerson = (request) => {
  const url = `${API_ROOT}/proposal/thaid/genarate-url`
  return doPost(url, request)
}
